import React from 'react'
import {
  CssBaseline,
  ThemeProvider
} from '@mui/material'
import useCurrentTheme from '../hooks/useCurrentTheme'

type ThemeWrapperProps = {
  children: React.ReactNode
}

const ThemeWrapper = ({ children }: ThemeWrapperProps) => {
  const theme = useCurrentTheme()
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export default ThemeWrapper
